import React from 'react';

export const DevelopersTableHeaderData = [
  {
    id: 4,
    label: 'Created By',
    input: 'createdBy',
    isHiddenFilter: false,
    fieldType: 'searchField',
    fieldKey: 'createdBy',
    isDefaultFilterColumn: true,
    isSortable: true,
    data: {
      type: 'string',
      title: 'Created By',
      description: 'General Information',
      searchKey: 'User',
      iconField: '',
      dependOn: '',
      multi: 'false',
      default: '',
      isSearchable: false,
      searchableKey: 'createdBy',
      displayPath: 'createdBy',
    },
  },
  {
    id: 5,
    label: 'Creation Date',
    input: 'createdOn',
    isHiddenFilter: false,
    fieldKey: 'createdOn',
    fieldType: 'alt-date',
    isDefaultFilterColumn: true,
    isDate: true,
    fieldType: 'alt-date',
    isSortable: true,
  },
  {
    id: 6,
    label: 'Updated By',
    input: 'updatedBy',
    isHiddenFilter: false,
    fieldType: 'searchField',
    fieldKey: 'updatedBy',
    isDefaultFilterColumn: true,
    isSortable: true,
    data: {
      type: 'string',
      title: 'Updated By',
      description: 'General Information',
      searchKey: 'User',
      iconField: '',
      dependOn: '',
      multi: 'false',
      default: '',
      isSearchable: false,
      searchableKey: 'updatedBy',
      displayPath: 'updatedBy',
    },
  },
  {
    id: 7,
    label: 'UpdateOn Date',
    input: 'updateOn',
    isHiddenFilter: false,
    fieldType: 'alt-date',
    fieldKey: 'updateOn',
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    fieldType: 'alt-date',
  },
  {
    id: 8,
    label: 'Progress',
    input: 'data_completed',
    fieldKey: 'data_completed',
    textInputType: 'number',
    textInputMax: 100,
    textInputMin: 0,
    fieldType: 'number',
    isDefaultFilterColumn: true,
    isNumber: true,
    isSortable: false,
    isHiddenFilter: true,
    component: (item) => <span>{item?.progressWithPercentage}</span>,
  },
  {
    id: 9,
    label: 'Email',
    fieldKey: 'email',
    isHiddenFilter: false,
    isDefaultFilterColumn: true,
    input: 'email',
    fieldType: 'text',
    isSortable: true,
    searchableKey: 'email',
  },
  {
    id: 10,
    label: 'Has Agreement',
    input: 'hasAgreement',
    fieldKey: 'hasAgreement',
    isSortable: true,
    searchableKey: 'HasAgreement',
    fieldType: 'select',
    isDefaultFilterColumn: true,
    data: {
      enum: [
        { key: 'yes', name: 'yes' },
        { key: 'no', name: 'no' },
      ],
    },
    withSelectFilter: true,
    component: (item) => <div>{item?.hasAgreement}</div>,
    optionFilterList: [
      { key: 'yes', value: 'yes' },
      { key: 'no', value: 'no' },
    ],
  },
  {
    id: 11,
    label: 'Agreement Document',
    isSortable: true,
    fieldKey: 'agreementDocument',
    input: 'AgreementDocument',
    displayPath: 'agreementDocument',
    searchableKey: 'agreementDocument',
    data: {
      enum: [
        { key: 'yes', name: 'yes' },
        { key: 'no', name: 'no' },
      ],
    },
    fieldType: 'select',
    component: (item) => <div>{item?.agreementDocument}</div>,
    isHiddenFilter: false,
    isDefaultFilterColumn: false,
    withSelectFilter: true,
    optionFilterList: [
      { key: 'yes', value: 'yes' },
      { key: 'no', value: 'no' },
    ],
  },
];
